import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.format = this.format.bind(this)
    this.element.addEventListener('input', this.format)
    this.element.addEventListener('blur', this.format)

    // Ensure the initial value is formatted when the controller connects.
    this.format()
  }

  disconnect() {
    this.element.removeEventListener('input', this.format)
    this.element.removeEventListener('blur', this.format)
  }

  format() {
    const input = this.element
    if (!input) return

    const digits = input.value.replace(/[^\d]/g, '')
    if (digits.length === 0) {
      input.value = ''
      return
    }

    const normalized = digits.replace(/^0+/, '') || '0'
    const dollars = normalized.length > 2 ? normalized.slice(0, -2) : '0'
    const cents = normalized.slice(-2).padStart(2, '0')

    input.value = `${dollars}.${cents}`

    // Keep the caret at the end of the input after formatting.
    requestAnimationFrame(() => {
      const length = input.value.length
      input.setSelectionRange(length, length)
    })
  }
}
